import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { CoachAssignmentStatus } from "@flexv-coach/shared";
import { planApi } from "@/lib/api";

export interface PlanFilters {
    from: string;
    to: string;
    outletId: string;
    status: CoachAssignmentStatus | "";
}

export function useCoachPlan(filters: PlanFilters) {
    return useQuery({
        queryKey: ["coach-plan", filters],
        queryFn: ({ signal }) =>
            planApi.get({
                from: filters.from,
                to: filters.to,
                outletId: filters.outletId || undefined,
                status: filters.status || undefined,
            }, signal),
    });
}

export function useUpdateAssignmentStatus() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({
            assignmentId,
            status,
            notes,
        }: {
            assignmentId: string;
            status: CoachAssignmentStatus;
            notes?: string;
        }) => planApi.updateStatus(assignmentId, status, notes),
        onSuccess: () => {
            // Satu mutasi dipakai menu Plan, Assignment, dan Dashboard —
            // semua cache yang terpengaruh dibersihkan di sini.
            void queryClient.invalidateQueries({ queryKey: ["coach-plan"] });
            void queryClient.invalidateQueries({ queryKey: ["coach-assignments"] });
            void queryClient.invalidateQueries({ queryKey: ["coach-dashboard"] });
            void queryClient.invalidateQueries({ queryKey: ["coach-profile"] });
        },
    });
}
